import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, transientOptions } from "shared/lib/styles";

import { Button } from "scmp-app/components/common/button";
import { EntityLink } from "scmp-app/components/entity-link";
import { NotificationItem } from "scmp-app/components/news-ticker/notification-item";
import { CloseButton } from "scmp-app/components/news-ticker/notification-item/styles";

import type { Type } from ".";

export const StyledEntityLink = styled(EntityLink)`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
`;

export const Label = styled.span`
  margin-inline-end: 8px;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  text-transform: uppercase;
`;

export const Title = styled.span``;

export const ReadButton = styled(Button)`
  block-size: 25px;
  margin-inline-start: 12px;
  padding-block: 4px;
  padding-inline: 10px;

  border-radius: 2px;
`;

type Props = {
  $type: Type;
};

export const NotificationContainer = styled(NotificationItem, { ...transientOptions })<Props>`
  block-size: 50px;

  ${props => {
    switch (props.$type) {
      case "breaking":
        return css`
          background: #001246;
          ${Label} {
            color: #ffca05;
          }
          ${Title} {
            color: #ffffff;
          }
          ${ReadButton} {
            color: #001246;

            background: #ffca05;
          }
          ${CloseButton} {
            color: #ffffff;

            background: #32416b;
          }
        `;
      case "section":
        return css`
          background: #dfe6fa;
          ${Label} {
            color: #000000;
          }
          ${Title} {
            color: #000000;
          }
          ${ReadButton} {
            color: #ffffff;

            background: #4585ff;
          }
          ${CloseButton} {
            color: #ffffff;

            background: #c1c5cf;
          }
        `;
    }
  }}
`;
